import React from 'react';
import { Logo } from '../../../components';

export const ReactLogo: React.FC = () => (
    <div className="d-flex flex-row align-items-center">
        <Logo style={{ height: 50, width: 55 }} />
        <div className="d-flex flex-column pl-2">
            <span className="font-weight-bold text-nowrap">
                Member Management
            </span>
            <span className="small">PSWT Union</span>
        </div>
    </div>
);
